// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { ValidatorResult } from "../ui/types/Types";

export const validate = (values: {
  [key: string]: string | string[] | undefined;
}): ValidatorResult => {
  const result: ValidatorResult = {
    validate: true,
    message: ""
  };
  if (values?.keywords === undefined || values.keywords.length === 0) {
    result.validate = false;
    result.message = "thematic_dossier.submit.error.keywords";
    return result;
  }
  if (values?.color === undefined) {
    result.validate = false;
    result.message = "thematic_dossier.submit.error.color";
    return result;
  }
  return result;
};
